<template>
  <div class="home container">
    <template v-if="isSignedIn">
      <div class="favorites">
        Your <svg title="Red Paper Heart" id="RedPaperHeartLogo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50" viewBox="-15 0 94.5 49" xml:space="preserve" fill="#ED184D">
        <polygon points="64.5,0 45.6,0 32.2,12.8 18.9,0 0,0 0,18.1 32.2,49 64.5,18.1 " class="logo"></polygon></svg> folders:
        <toggle-favorite-folder style="display: inline;" :favorite="favorite" :key="favorite.id" v-for="favorite in favoriteList" />
      </div>
      <div>
        Debug:
        <!-- <button class="btn btn-outline-primary btn-sm " @click.stop.prevent="cleargFilesdata" >clear cached files</button> -->
        <button class="btn btn-outline-primary btn-sm " @click.stop.prevent="clearCache" >clear user settings</button>
        <!-- <button class="btn btn-outline-primary btn-sm " @click.stop.prevent="forceApiCall" >refresh cached files</button> -->
      </div>
    </template>
    <g-files-in-folders-list :key="loadingFolders.join()" :gFolder="rootFolder" :gFolderChildrenIds="rootFolderChildrenIds" :breadcrumbsAutoLoadStopAtIds="loadingFolderParents"/>
  </div>
</template>

<script>
// @ is an alias to /src
import { GApiMixin } from '@/mixins/GApiMixin.js'
import ToggleFavoriteFolder from '@/components/ToggleFavoriteFolder'
// import { mapState } from 'vuex'

export default {
  name: 'Home',
  mixins: [GApiMixin],
  components: {
    ToggleFavoriteFolder
  },
  data () {
    return {
      // currentlyLoaded: ''
      loadingFolders: []
    }
  },
  watch: {
    isSignedIn (val, oldVal) {
      if (val) this.fetchData()
    },
    selectedFolder (val, oldVal) {
      // console.log('home.watch:selectedFolder called', this.selectedFolder)
      if (this.selectedFolder.length) {
        const q = this.selectedFolder.join()
        if (this.$route.params.id !== q) {
        //   console.log('home.watch:selectedFolder called - pushing new rout to review/')
          this.$router.push({ name: 'Review', params: { id: q } })
        }
      } else if (this.$route.name !== 'Home') {
        this.$router.push({ name: 'Home' })
      }
    },
    $route: {
      // immediate: true,
      handler (to, from) {
        if (to.name === 'Home' && this.selectedFolder.length) {
          this.$store.commit('clearSelectedFolder') // when click back to home page, it should clear all selected folders.
        }
        if (to.name === 'Review' && this.selectedFolder.join() !== to.params.id) {
          this.selectedFolder = to.params.id.split(',')
        }
        if (to.name === 'Home' || to.name === 'Review') {
          //  console.log('home.watch:$route - calling fetchData')
          this.fetchData()
        }
      }
    }
  },
  mounted () {
    if (this.$route.name === 'Review') {
      this.selectedFolder = this.$route.params.id.split(',')
    }
    this.fetchData(false)
  },
  computed: {
    selectedFolder: {
      get () {
        return this.$store.state.selectedFolder
      },
      set (val) {
        this.$store.state.selectedFolder = val
      }
    },
    favoriteList () {
      return this.$store.state.settings.favorites
    },
    rootFolder () {
      if (this.loadingFolders.length > 1) {
        return {
          kind: 'drive#file',
          id: 'rph-root',
          name: 'Combining ' + this.loadingFolders.length + ' folders',
          mimeType: 'application/vnd.google-apps.folder'
          // description: 'Combining ' + this.loadingFolders.length + ' folders'
        }
      } else if (this.loadingFolders.length === 1) {
        return this.gFilesMap[this.loadingFolders[0]]
      } else {
        return undefined
      }
    },
    rootFolderChildrenIds () {
      let children = []
      for (let i = 0; i < this.loadingFolders.length; i++) {
        if (Object.prototype.hasOwnProperty.call(this.gFilesMap, this.loadingFolders[i])) {
          for (let j = 0; j < this.gFilesMetaMap[this.loadingFolders[i]].children.length; j++) {
            children.push(this.gFilesMap[this.gFilesMetaMap[this.loadingFolders[i]].children[j]])
          }
        }
      }
      // sort children based on their parent's name. parent name has "review" then move to top and it's children in alphabetical order
      children.sort((a, b) => {
        const nameA = a.name.toUpperCase().replace(/[^A-Z0-9]/ig, '_')
        const nameB = b.name.toUpperCase().replace(/[^A-Z0-9]/ig, '_')
        if (this.gFilesMap[a.parents[0]].name.search(/review/i) > -1 && this.gFilesMap[b.parents[0]].name.search(/review/i) > -1) {
          if (nameA < nameB) {
            return 1
          }
          if (nameA > nameB) {
            return -1
          }
          return 0
        } else if (this.gFilesMap[a.parents[0]].name.search(/review/i) === -1 && this.gFilesMap[b.parents[0]].name.search(/review/i) === -1) {
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }
          return 0
        } else if (this.gFilesMap[a.parents[0]].name.search(/review/i) === -1 && this.gFilesMap[b.parents[0]].name.search(/review/i) > -1) {
          return 1
        } else {
          return -1
        }
      })
      children = children.map(x => x.id)
      // remove duplicate items
      const uniqChildren = children.reduce((a, b) => { if (a.indexOf(b) < 0) a.push(b); return a }, [])
      return uniqChildren
    },
    loadingFolderParents () {
      const parents = []
      for (let i = 0; i < this.loadingFolders.length; i++) {
        if (Object.prototype.hasOwnProperty.call(this.gFilesMap, this.loadingFolders[i])) {
          for (let j = 0; j < this.gFilesMap[this.loadingFolders[i]].parents.length; j++) {
            parents.push(this.gFilesMap[this.loadingFolders[i]].parents[j])
          }
        }
      }
      return parents
    }
  },
  methods: {
    fetchData (forceApiCall) {
      if (this.selectedFolder.length) {
        this.loadingFolders = this.selectedFolder
      } else {
        this.loadingFolders = this.favoriteList.map(x => x.id)
      }
      //  console.log('home.fetchData(' + forceApiCall + ') called. loading ' + this.loadingFolders.length + ' folders')
      if (this.isInitialized && this.loadingFolders.length) {
        this.getFiles(this.loadingFolders, forceApiCall)
          .then(files => {
            // update the favourite items with latest data, e.g. make sure name, decriptions are up to date
            for (const file in files) {
              if (this.$store.getters.isFavorite(file.id)) {
                this.$store.commit('setFavoriteItem', file)
              }
            }
            this.getFilesInParents(this.loadingFolders, true, forceApiCall)
          })
          .catch(err => {
            // console.log(err)
            // console.log(err.status, err.result.error.message)
            if (err.status === 404) {
              // console.log('404 not found.. try to remove')
              alert(err.result.error.message)
            }
          })
      }
    },
    // cleargFilesdata () {
    //   console.log('clearing cached files: gFilesMap / gFilesMetaMap')
    //   localStorage.removeItem('gFilesMetaMap')
    //   localStorage.removeItem('gFilesMap')
    // },
    clearCache () {
      localStorage.removeItem(`${this.googleUser.getId()}`)
    }
    // forceApiCall () {
    //   this.fetchData(true)
    // }
  }
}
</script>
